function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Modal.css';
import React, { useEffect, useState } from 'react';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { CloseButton } from '../../../../atoms/CloseButton/CloseButton';
import { IconMail } from '../../../../atoms/Icons';
import ComponentsWrapper from '../../../../atoms/ComponentsWrapper';
import { useOnKeyPress } from '../../../../../utils/hooks/useOnKeyPress';
import { TextInput } from './FormFields';
import { getDictionaryItem, get } from '../../../../../utils';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import Loader from '../../loader';
import { Notify } from '../../actions';
const Modal = _ref => {
  let {
    rtl,
    hide,
    dictionary,
    isRedirectModal = false,
    apiConfig,
    context
  } = _ref;
  const {
    buttonBackUrl,
    popup2ButtonTitle,
    popup2ButtonUrl,
    popup2ShortDescription,
    popup2Title,
    popup3ButtonTitle,
    popup3ButtonUrl,
    popup3ShortDescription,
    popup3Title,
    popupButtonTitle,
    popupShortDescription,
    popupTitle
  } = dictionary;
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState({
    notifyEmail: {
      value: '',
      name: 'notifyEmail',
      type: 'email',
      label: getDictionaryItem(dictionary, 'EmailAddressInterest'),
      required: true,
      valid: false
    }
  });
  const validForm = get(email['notifyEmail'], 'valid') && get(email['notifyEmail'], 'validatePattern') || false;
  const submitForm = async () => {
    setIsLoading(true);
    const result = await Notify(apiConfig, _objectSpread(_objectSpread({}, context), email));
    setIsLoading(false);
    if (result) setSubmitted(true);else hide();
  };
  useEffect(() => {
    document.body.classList.add('prevent-scroll');
    return () => {
      document.body.classList.remove('prevent-scroll');
    };
  }, []);
  useOnKeyPress(['Escape', 'Esc'], hide);
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    role: "dialog",
    "aria-labelledby": "wizard-title"
  }, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal__container"
  }, /*#__PURE__*/React.createElement(CloseButton, {
    className: "modal__close",
    onClick: hide,
    isCircleButton: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "row no-gutter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-1 "
  }, /*#__PURE__*/React.createElement(IconMail, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-11 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal__col"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h4",
    className: "h4",
    field: isRedirectModal ? get(popup3Title, 'jss') : submitted ? get(popup2Title, 'jss') : get(popupTitle, 'jss')
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: "description",
    field: isRedirectModal ? get(popup3ShortDescription, 'jss') : submitted ? get(popup2ShortDescription, 'jss') : get(popupShortDescription, 'jss')
  }), !isRedirectModal ? /*#__PURE__*/React.createElement("div", {
    className: "modal__actions"
  }, !submitted && /*#__PURE__*/React.createElement(TextInput, _extends({}, email['notifyEmail'], {
    updateContext: setEmail
  })), submitted ? /*#__PURE__*/React.createElement(Link, {
    className: `btn btn-secondary`,
    field: {
      href: get(popup2ButtonUrl, 'jss.value.href') || get(buttonBackUrl, 'jss.value.href')
    }
  }, get(popup2ButtonTitle, 'jss.value')) : /*#__PURE__*/React.createElement("button", {
    className: `btn btn-primary ${!validForm ? 'disabled' : ''} ${isLoading ? 'loading' : ''}`,
    onClick: () => validForm && submitForm()
  }, isLoading ? /*#__PURE__*/React.createElement(Loader, null) : '', /*#__PURE__*/React.createElement("span", null, " ", get(popupButtonTitle, 'jss.value')))) : /*#__PURE__*/React.createElement("div", {
    className: "modal__actions"
  }, /*#__PURE__*/React.createElement(Link, {
    className: `btn btn-secondary`,
    field: {
      href: get(popup3ButtonUrl, 'jss.value.href')
    }
  }, get(popup3ButtonTitle, 'jss.value')))))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: ` `
  }, children);
};
export default Modal;
const commonStyles = "c6gestv";
const rtlStyles = "rx984jl";
const ltrStyles = "l1yozncl";